import { render, staticRenderFns } from "./ContactTab.vue?vue&type=template&id=9cda653a&"
import script from "./ContactTab.vue?vue&type=script&lang=js&"
export * from "./ContactTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports